import { includes, reduce } from 'ramda'

/**
 * @param {Uint8Array} buffer
 * @returns {string}
 */
const getMimeTypeByBuffer = (buffer) => {
  const header = reduce(
    (accumulator, item) => accumulator + item.toString(16),
    '',
    new Uint8Array(buffer).subarray(0, 4)
  )

  switch (header) {
    case '89504e47':
      return 'image/png'
    case '47494638':
      return 'image/gif'
    case 'ffd8ffe0':
    case 'ffd8ffe1':
    case 'ffd8ffe2':
      return 'image/jpeg'
    case '25504446':
      return 'application/pdf'
    default:
      return ''
  }
}

/**
 * @param {string} type
 * @param {string[]} acceptedTypes
 */
const validateMimeByString = (type, acceptedTypes) =>
  includes(type, acceptedTypes)

/**
 * @param {number} size
 * @param {number} minSize
 * @param {number} maxSize
 * @returns {boolean}
 */
const validateSize = (size, minSize, maxSize) =>
  (size >= minSize && size <= maxSize)

export {
  getMimeTypeByBuffer,
  validateMimeByString,
  validateSize
}
